export enum ACHIEVEMENT_LOCK_DATE_MONTH_TYPES {
  CURRENT_MONTH = 'CURRENT_MONTH',
  PREVIOUS_MONTH = 'PREVIOUS_MONTH',
}

export enum ACHIEVEMENT_RELATED_CHANNELS {
  PARTNERSHIP = 'Partnership',
  SALES_TO_CORPORATE_CUSTOMERS = 'Sales To Corporate Customers',
}
